import alt from 'components/Dispatcher';
import CardReasonSource from 'sources/CardReasonSource';
import generateAsyncActions from 'utils/generateAsyncActions';

class CardReasonEditActions {
  constructor() {
    this.generateActions(
      ...generateAsyncActions(
        'fetchCardReasonScheme',
        'saveCardReasonScheme',
        'saveCardReasonScheme'
      ),
      'initializeForm',
      'updateForm',
      'initNewFormForScoringScheme'
    );
  }

  fetchCardReasonScheme(schemeId) {
    return dispatch => {
      dispatch(schemeId);
      return CardReasonSource.fetchCardReasonScheme(schemeId).then(
        this.fetchCardReasonSchemeSuccess,
        this.fetchCardReasonSchemeError
      );
    };
  }

  saveCardReasonScheme(cardScheme) {
    return dispatch => {
      dispatch();
      if (cardScheme.id == null) {
        return CardReasonSource.createCardReasonScheme(cardScheme).then(
          this.saveCardReasonSchemeSuccess,
          this.saveCardReasonSchemeError
        );
      } else {
        return CardReasonSource.updateCardReasonScheme(cardScheme).then(
          this.saveCardReasonSchemeSuccess,
          this.saveCardReasonSchemeError
        );
      }
    };
  }

  deleteCardReasonScheme(schemeId) {
    return dispatch => {
      dispatch(schemeId);
      return CardReasonSource.deleteCardReasonScheme(schemeId).then(
        this.deleteCardReasonSchemeSuccess,
        this.deleteCardReasonSchemeError
      );
    };
  }
}

export default alt.createActions(CardReasonEditActions);
